'use client';

import React, { useEffect, useState } from 'react';
import ExpandCollapseButton from '../ExpandCollapseButton/ExpandCollapseButton';
import { useSideNavOpen } from '@/store';

const TopExpandButton = () => {
	const sideNavOpen = useSideNavOpen();

	const [isMounted, setIsMounted] = useState(false);
	useEffect(() => {
		setIsMounted(true);
	}, []);

	if (!isMounted || sideNavOpen) return null;

	return (
		<div
			className="w-full bg-midnight-blue z-50 sticky top-0 right-5 flex justify-center items-center  flex-col pt-4 pb-[5px] px-2.5"
			style={{
				boxShadow: '0px -1px 2px 0px rgba(0, 0, 0, 0.25)',
			}}
		>
			<ExpandCollapseButton />
		</div>
	);
};

export default TopExpandButton;
